import React, { useState } from 'react'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import Members from '../../../../api/Members'
import useTitle from '../../../../elements/Hooks/useTitle'
import { get, isEmpty, pick } from 'lodash'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import AddEnquiry from '../../../../components/Sales/Enquiries/AddEnquiry/AddEnquiry'
import { withRouter } from 'react-router-dom'
import { dateFormat, dateVal, strVal } from '../../../../modules/Utils'
import DocumentsApi from '../../../../api/Documents'
import Email from '../../../../api/Email'
import Templates from '../../../../api/Templates'
import { message } from 'antd'
import { compose } from 'recompose'
import useModalData from '../../../../elements/Hooks/useModalData'

export const AddEnquiryContext = React.createContext({})
const templateApi = new Templates()
const emailApi = new Email()
const docsApi = new DocumentsApi()

function AddEnquiriesCont(props) {
  const key = get(props.match, 'params.key')
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, object: enquiry, setObject: setEnquiry } = useFetchObject(
    () => EnquiriesApi.read(key),
    false,
    [key],
    isEmpty(key)
  )

  const { fetch: fetchAction, fetching: fetchingActions, list: actions } = useFetchList(
    () => docsApi.actions('enquiries', enquiry.status),
    [enquiry.status],
    isEmpty(enquiry.status)
  )

  const [submitting, submitFunc] = useSubmit(EnquiriesApi.create)
  const [updating, updateFunc] = useSubmit(EnquiriesApi.update)
  const [cancelling, cancelFunc] = useSubmit(EnquiriesApi.cancel)
  const [reopening, reopenFunc] = useSubmit(EnquiriesApi.reopen)
  const [losing, loseFunc] = useSubmit(EnquiriesApi.lose)

  const { visible: visiblePhonebook, onShow: onShowPhoneBook, onCancel: onCancelPhoneBook, isNew } = useModalShow()

  const { formRef } = useModalData(
    EnquiriesApi.create,
    EnquiriesApi.update,
    EnquiriesApi.cancel,
    EnquiriesApi.reopen,
    EnquiriesApi.lose,
    fetch
  )

  const {
    list: enquirerList,
    fetching: fetchingEnquirer,
    fetch: fetchEnquirer,
  } = useFetchList(EnquiriesApi.enquirerList, [visiblePhonebook])

  const [isMemberOrganization, setIsMemberOrganization] = useState(true)
  const [ContactPersonLoading, setContactPersonLoading] = useState(false)
  const [contactPerson, setContactPerson] = useState([])

  //useTitle(enquiry.code === undefined ? `Create New Enquiry` : `${enquiry.code} Enquiry`)

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingEnquiryTemplate, submitEnquiryTemplate] = useSubmit(emailApi.enquiryTemplate, true)

  const [emailOptions, setEmailOptions] = useState({})

  async function showEmail() {
    const emailEnquiry = { ...enquiry }
    if (emailEnquiry.status !== 'New Lead') {
      message.error(`Enquiry has already been Acknowledged`)
      return
    }
    const hide = message.loading('Fetching Email Template...', 0)
    try {
      const emailLines = [emailEnquiry].map((i) => ({
        date: dateFormat(dateVal(i, 'date')),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        type: strVal(i, 'type'),
        title: strVal(i, 'title'),
        /*amount: moneyInline(
          round(sum(lines.map(d => numVal(d, 'amount.net'))), 2),
          strVal(i, 'currency'),
        ),*/
        dueDate: dateFormat(dateVal(i, 'date.due')),
      }))
      const enquiryTemplate = await templateApi.read(
        strVal(emailEnquiry, 'company._id').replace('members/', ''),
        'enquiry'
      )
      const emailDetails = get(enquiryTemplate, 'emailACK') || {}

      const data = await emailApi.enquiryTemplate({
        receiver: get(emailEnquiry, 'enquirer_rep.fn'),
        companyRep: get(emailEnquiry, 'sales_rep.fn'),
        company: get(emailEnquiry, 'company.fn'),
        code: get(emailEnquiry, 'code'),
        clientRef: get(emailEnquiry, 'reference.no'),
        lines: emailLines,
        ...emailDetails,
      })
      const filesList = await EnquiriesApi.files([emailEnquiry].map((s) => s._id))
      const filesMapped = filesList.map((f) => f.uuid)
      setEmailOptions({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        docStatus: 'Opportunity',
        emailLines: [emailEnquiry],
        emailDetails: {
          to: get(emailEnquiry, 'enquirer_rep.email.label'),
          cc: get(emailEnquiry, 'sales_rep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: `[${get(emailEnquiry, 'code')}] ${get(emailDetails, 'subject')}`,
          attachments: filesMapped,
        },
      })
      hide()
    } catch (e) {
      hide()
      //console.log(e)
      message.error(e.errorMessage)
      setEmailOptions({ fetchingEmailTemplate: false })
    }
  }

  async function showEmailDEC() {
    const emailEnquiry = { ...enquiry }
    if (emailEnquiry.status === 'Declined') {
      message.error(`Enquiry has already been Declined`)
      return
    }
    const hide = message.loading('Fetching Email Template...', 0)
    try {
      const emailLines = [emailEnquiry].map((i) => ({
        date: dateFormat(dateVal(i, 'date')),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        type: strVal(i, 'type'),
        title: strVal(i, 'title'),
        /*amount: moneyInline(
          round(sum(lines.map(d => numVal(d, 'amount.net'))), 2),
          strVal(i, 'currency'),
        ),*/
        dueDate: dateFormat(dateVal(i, 'date.due')),
      }))
      const enquiryTemplate = await templateApi.read(
        strVal(emailEnquiry, 'company._id').replace('members/', ''),
        'enquiry'
      )
      const emailDetails = get(enquiryTemplate, 'emailDEC') || {}

      const data = await emailApi.enquiryTemplate({
        receiver: get(emailEnquiry, 'enquirer_rep.fn'),
        companyRep: get(emailEnquiry, 'sales_rep.fn'),
        company: get(emailEnquiry, 'company.fn'),
        code: get(emailEnquiry, 'code'),
        clientRef: get(emailEnquiry, 'reference.no'),
        lines: emailLines,
        ...emailDetails,
      })
      const filesList = await EnquiriesApi.files([emailEnquiry].map((s) => s._id))
      const filesMapped = filesList.map((f) => f.uuid)
      setEmailOptions({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        //emailFiles: filesList,
        docStatus: 'Declined',
        emailLines: [emailEnquiry],
        emailDetails: {
          to: get(emailEnquiry, 'enquirer_rep.email.label'),
          cc: get(emailEnquiry, 'sales_rep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: `[${get(emailEnquiry, 'code')}] ${get(emailDetails, 'subject')}`,
          attachments: filesMapped,
        },
      })
      hide()
    } catch (e) {
      hide()
      //console.log(e)
      message.error(e.errorMessage)
      setEmailOptions({ fetchingEmailTemplate: false })
    }
  }

  function onCancelEmail() {
    setEmailOptions({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }

  useTitle(type === 'new' ? `Create New Enquiry` : `${enquiry.code} Enquiry`)

  async function onChangeEnquirer(id) {
    if (id) {
      setContactPersonLoading(true)
      const key = id.replace('members/', '')
      const membersApi = new Members()
      const memberResponse = await membersApi.get(key)
      let memberData = await memberResponse.json()
      setIsMemberOrganization(memberData.kind !== 'individual')
      const response = await membersApi.representatives.list(key)
      let data = await response.json()
      setContactPerson(data)
      setContactPersonLoading(false)
      return id
    }
  }

  React.useEffect(() => {
    onChangeEnquirer(get(enquiry, 'enquirer._id'))
  }, [get(enquiry, 'enquirer._id')])

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/clients/enquiries/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const enquiryDB = await updateFunc({
      ...pick(enquiry, ['_key', '_id', '_rev']),
      ...values,
    })
    if (enquiryDB) setEnquiry(enquiryDB)
  }

  async function cancel() {
    const cancelled = await cancelFunc({
      ...pick(enquiry, ['_key', '_rev', '_id']),
    })
    if (cancelled) await fetch()
    props.history.replace({
      pathname: `/clients/enquiries/${enquiry._key}/update`,
    })
    this.props.refresh()
  }

  async function reopen() {
    const reopened = await reopenFunc({
      ...pick(enquiry, ['_key', '_rev', '_id']),
    })
    await fetch()
    if (reopened)
      props.history.replace({
        pathname: `/clients/enquiries/${enquiry._key}/update`,
      })
  }

  async function lose() {
    const lost = await loseFunc({
      ...pick(enquiry, ['_key', '_rev', '_id']),
    })
    await fetch()
    if (lost)
      props.history.replace({
        pathname: `/clients/enquiries/${enquiry._key}/update`,
      })
  }

  const [submittingOperation, submitOperation] = useSubmit(EnquiriesApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      case 'cancel':
        const cancelled = await cancelFunc({
          ...pick(enquiry, ['_key', '_rev', '_id']),
        })
        await fetch()
        if (cancelled)
          props.history.replace({
            pathname: `/clients/enquiries/${enquiry._key}/update/update`,
          })
        break
      case 'reopen':
        const reopened = await reopenFunc({
          ...pick(enquiry, ['_key', '_rev', '_id']),
        })
        await fetch()
        if (reopened)
          props.history.replace({
            pathname: `/clients/enquiries/${enquiry._key}/update`,
          })
        break
      case 'lose':
        const lost = await loseFunc({
          ...pick(enquiry, ['_key', '_rev', '_id']),
        })
        await fetch()
        if (lost)
          props.history.replace({
            pathname: `/clients/enquiries/${enquiry._key}/update`,
          })
        break
      default:
        const enquiryDB = await submitOperation(operation, pick(enquiry, ['_key', '_rev', '_id']))
        if (enquiryDB) setEnquiry(enquiryDB)
        break
    }
    hide()
  }

  const isUpdatable = actions.find((a) => a.key === 'update') || type === 'new'

  const [modalID, setModalID] = React.useState(1)
  React.useEffect(() => {
    setModalID((old) => old + 1)
  }, [enquirerList.length])
  return (
    <AddEnquiryContext.Provider
      value={{
        ...emailOptions,
        type,
        fetching,
        // fetchLines,
        //fetchingLines,
        submitting,
        updating,
        isUpdatable,
        fetch,
        enquiry,
        actions,
        fetchAction,
        fetchingActions,
        handleActions,
        submit,
        cancelling,
        reopening,
        losing,
        cancel,
        reopen,
        lose,
        update,
        //email
        showEmail,
        showEmailDEC,
        onCancelEmail,
        formRef,
        visiblePhonebook,
        onShowPhoneBook,
        onCancelPhoneBook,
        onChangeEnquirer,
        contactPerson,
        setContactPerson,
        enquirerList,
        fetchingEnquirer,
        fetchEnquirer,
        ContactPersonLoading,
        setContactPersonLoading,
        isMemberOrganization,
        modalID,
        isNew,
        submittingTemplate,
        submitTemplate,
        submittingEnquiryTemplate,
        submitEnquiryTemplate,
      }}>
      <AddEnquiry />
    </AddEnquiryContext.Provider>
  )
}

AddEnquiriesCont.propTypes = {}
AddEnquiriesCont.defaultProps = {}

export default compose(withRouter)(AddEnquiriesCont)
